import React, { FC } from 'react'
import { GlobalizedArtistInfoProps } from 'modules/Globalize/containers/GlobalizedArtistInfo/GlobalizedArtistInfo.props'
import { ArtistMainInfo } from 'modules/Projects/components'
import './GlobalizedArtistInfo.scss'
import { isEmpty } from 'shared/utils/isEmpty'
import { SkeletonArtistInfo } from 'modulesCommon/Skeleton/ProjectDetails'

const GlobalizedArtistInfo: FC<GlobalizedArtistInfoProps> = ({ activeArtist, activeProject }) => {

  return (
    <div className="globalized-artist">
      {
        !isEmpty(activeArtist) ? (
          <ArtistMainInfo
            artist={activeArtist}
            project={activeProject}
            canEdit={false}
            offset={false}
          />
        ) : (
          <SkeletonArtistInfo />
        )
      }
    </div>
  )
}

export default GlobalizedArtistInfo
